import { ALL_LOCALE_CODES } from '~/utils/excludedLocales';


export function stripLocalePrefix(fullPath: string, localeCodes: readonly string[]): string {
  const queryIndex = fullPath.indexOf('?');
  const pathname = queryIndex === -1 ? fullPath : fullPath.slice(0, queryIndex);
  const search = queryIndex === -1 ? '' : fullPath.slice(queryIndex);
  const segments = pathname.split('/').filter(Boolean);

  if (segments[0] && localeCodes.includes(segments[0])) {
    segments.shift();
  }

  const path = segments.length > 0 ? `/${segments.join('/')}` : '/';

  return `${path}${search}`;
}

/**
 * Builds a locale-prefixed path for `strategy: 'prefix'` without calling `localePath`
 * (which can return "" if the router is not ready during PWA cold start).
 */
export function buildLocalizedPath(path: string, locale: string): string {
  const queryIndex = path.indexOf('?');
  const pathname = queryIndex === -1 ? path : path.slice(0, queryIndex);
  const search = queryIndex === -1 ? '' : path.slice(queryIndex);

  let normalized = pathname;

  if (pathname === '/' || pathname === '') {
    normalized = '';
  } else if (!pathname.startsWith('/')) {
    normalized = `/${pathname}`;
  }

  return `/${locale}${normalized || '/'}${search}`;
}

export function replacePathLocale(fullPath: string, locale: string): string {
  return buildLocalizedPath(stripLocalePrefix(fullPath, ALL_LOCALE_CODES), locale);
}
